import { render, staticRenderFns } from "./deleteTemplateDialog.vue?vue&type=template&id=04edb6ea&scoped=true&"
import script from "./deleteTemplateDialog.vue?vue&type=script&lang=js&"
export * from "./deleteTemplateDialog.vue?vue&type=script&lang=js&"
import style0 from "./deleteTemplateDialog.vue?vue&type=style&index=0&id=04edb6ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04edb6ea",
  null
  
)

export default component.exports